// extracted by mini-css-extract-plugin
export var arrows = "_5r-6";
export var decrementer = "_5r-a";
export var disabled = "_5r-4";
export var error = "_5r-1";
export var hiddenText = "_5r-b";
export var incrementer = "_5r-9";
export var input = "_5r-8";
export var inputWrapper = "_5r-0";
export var leadingIcon = "_5r-c";
export var readonly = "_5r-3";
export var regular = "_5r-7";
export var small = "_5r-5";
export var warning = "_5r-2";